// src/pages/Admin/StatistiquesComptabilite/components/ComptaQuickNav.jsx

import React from "react";
import { FaChevronRight } from "react-icons/fa";

import { scrollToSection } from "../utils/comptaDashboardUtils";

export default function ComptaQuickNav({ sections, openSections }) {
  return (
    <section className="sticky top-0 z-20 -mx-3 border-y border-slate-200 bg-slate-50/95 px-3 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-950/95 sm:-mx-5 sm:px-5 lg:static lg:mx-0 lg:rounded-[2rem] lg:border lg:bg-white lg:dark:bg-slate-900">
      <div className="mb-2 flex items-center justify-between gap-3">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
          Accès rapide
        </p>

        <FaChevronRight className="text-xs text-slate-400 lg:hidden" />
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1">
        {sections.map((section) => {
          const Icon = section.icon;
          const isOpen = !!openSections[section.key];

          return (
            <button
              key={section.key}
              type="button"
              onClick={() => scrollToSection(section.id)}
              className={`inline-flex shrink-0 items-center gap-2 rounded-2xl px-3 py-2 text-xs font-bold ring-1 transition ${
                isOpen
                  ? "bg-[#013E8E] text-white ring-[#013E8E]"
                  : "bg-white text-slate-700 ring-slate-200 hover:bg-slate-100 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
              }`}
            >
              <Icon />
              {section.shortTitle}
            </button>
          );
        })}
      </div>
    </section>
  );
}